import { Injectable } from '@angular/core';
import { DwAttributeType, DwContextDefinition, DwQueryMdAttribute, DwControlType, DwCustomContextBase, DwCustomContextDefinition, 
         DwExpressionCompareType, DwSecurityUserService, DwCacheService, DwExpressionAttribute, deepCopy } from '@devwareapps/devware-cap';
import { OperatorFunction, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppMetaDataItemNames, PayJobChangeEntity } from 'src/app/meta-data/app-meta-data.service';
import { PayJobChangeMetaDataItemNames, PayJobChangeMetaDataLookups } from '../meta-data/payjobchange-meta-data.service';
import { ConfigService } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { PafSecurityResultModel } from '../models/paf-security-result-model';
import { omit } from 'underscore';

@DwCustomContextDefinition({
    keyName: 'payJobChangeSecurityRulesContext',
    display: 'PayChange Security Rules',
    isGlobal: false,
    parentItem: PayJobChangeMetaDataItemNames.PayJobChange
})
@Injectable()
export class PayJobChangeSecurityRulesContext extends DwCustomContextBase {

    constructor(
        private dwSecurityUserService: DwSecurityUserService,
        private cacheService: DwCacheService,
        private http: HttpClient
    ) {
        super();
    }
    setupContextDefinition(contextDef: DwContextDefinition) {
        const cxtFunc = (resolvedContext => {
            if (!resolvedContext.data)
                return of(null);
            // contextDef.getCustomContextFunction = null;
            // const delayMs = 100;
            // const timeoutId = setTimeout(() => { contextDef.getCustomContextFunction = cxtFunc; }, delayMs)
            return this.canApproveRejectOb(resolvedContext.data);
        });

        contextDef.getCustomContextFunction = cxtFunc;
        contextDef.debounceTimeMs = 500;
        // contextDef.getCustomContextKey = (resolvedContext => {
        //     const payJobChange: PayJobChangeEntity = resolvedContext.data;

        //     return `PAF-${payJobChange?.EmployeeEthos_UserId}-${payJobChange?.EmployeeEthos_UserId}`;
        // });

        contextDef.attributes = [];
        var canApproveAttr = this.addUiProp(contextDef.attributes, 'CanApprove', 'Can Approve this PAF', DwAttributeType.YesNo);
        var canApproveMsg = this.addUiProp(contextDef.attributes, 'ApproveErr', 'Approve Message', DwAttributeType.Text);
        var canRejectAttr = this.addUiProp(contextDef.attributes, 'CanReject', 'Can Reject this PAF', DwAttributeType.YesNo);
        var canRejectMsg = this.addUiProp(contextDef.attributes, 'RejectErr', 'Reject Message', DwAttributeType.Text);
    }
    private addUiProp(attributes: DwQueryMdAttribute[], name: string, display: string, attrType?: DwAttributeType) : DwQueryMdAttribute {
        const controlType: DwControlType = attrType == DwAttributeType.YesNo ? DwControlType.Checkbox : DwControlType.Textbox;
        var attr : DwExpressionAttribute = this.addProperty(attributes, name, display, DwAttributeType.YesNo, controlType, null);
        attr.compareTypes = attrType == DwAttributeType.YesNo ? [DwExpressionCompareType.equal, DwExpressionCompareType.notEqual]
                            : [DwExpressionCompareType.equal, DwExpressionCompareType.notEqual, DwExpressionCompareType.isBlank, DwExpressionCompareType.isNotBlank];
        return attr;
    }
    private result(approveErr: string, rejectErr: string) : PafSecurityResultModel{
        rejectErr = rejectErr == '*' ? approveErr : rejectErr;
        return  { CanApprove: (approveErr ?? '').length == 0, ApproveErr: approveErr, 
                     CanReject: (rejectErr ?? '').length == 0, RejectErr: rejectErr };
    }
    private canApproveRejectOb(payJobChange: PayJobChangeEntity): Observable<PafSecurityResultModel> {
        const url = ConfigService.config.apiRoot + '/payJobChange/canAssess';
        if (payJobChange.EmployeeEthos_UserId == null || payJobChange.PayJobChangeId == null) 
            return of(this.result(payJobChange.EmployeeEthos_UserId == null ? 'No target employee selected' : 'Missing Pay Job Change Id', '*'));

        // Setting these values directly effect the cached item check and results in an infinite loop
        // if (typeof payJobChange.NewWage == 'string') payJobChange.NewWage = parseFloat(payJobChange.NewWage);
        // if (typeof payJobChange.CurrentWage == 'string') payJobChange.CurrentWage = parseFloat(payJobChange.CurrentWage);

        // Entities to apis have to be passed as strings, then parsed on the serve
        const payJobChangeJSON = JSON.stringify(payJobChange);

        let canApproveObs: Observable<PafSecurityResultModel> = this.http.post<PafSecurityResultModel>(url, payJobChangeJSON);

        const validOp : OperatorFunction<any, PafSecurityResultModel> = map(resp => this.result(resp.approve, resp.reject));
        const errOp : OperatorFunction<any, PafSecurityResultModel> =
          catchError(err => { 
            console.error(err.message);
            return of(this.result(err.message, '*'));
          });
        return canApproveObs.pipe(validOp, errOp);
    }
}